import Cookies from 'universal-cookie';

interface CookieOptions {
	path: string;
	httpOnly: boolean;
	expires?: Date;
}

export default class PreferenceCookieStorage {
	cookies: Cookies;

	cookieName: string;

	cookieOptions: CookieOptions;

	constructor(cookies: Cookies, cookieName: string, cookieOptions: CookieOptions) {
		this.cookies = cookies;
		this.cookieName = cookieName;
		this.cookieOptions = cookieOptions;
	}

	load(): string | null {
		return this.cookies.get(this.cookieName, { doNotParse: true });
	}

	save(value: string | null) {
		if (value) {
			this.cookies.set(this.cookieName, value, this.cookieOptions);
		} else {
			this.cookies.remove(this.cookieName, this.cookieOptions);
		}
	}
}
